import React from 'react';
import {ISelectProps,  SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchTrafficSource} from '~/modules/Clients/api';

type ISelectSellerProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectTrafficSource = ({
    disabled,
    ...props
}: ISelectSellerProps) => {
    const {resource, isPending} = useResource(() => fetchTrafficSource(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource, 'label', TableSortDirection.ASC)}/>;
};

export const SelectTrafficSourceField = (props: IFieldProps<ISelectSellerProps>) => <FormField {...props}>
    <SelectTrafficSource {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
